import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Tooltip } from "@/uiKit/atoms/Tooltip.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type InclusionAgentSourceProps = {
  id?: string;
  className?: string;
};

export const InclusionAgentSource: React.FC<InclusionAgentSourceProps> = ({ id, className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Tooltip
      id={id}
      className={cx(styles.container, className)}
      wrapperClassName={styles.wrapper}
      placement="bottom"
      content={<Typography>{t("inclusionAgent.source.tooltip")}</Typography>}
    >
      <Icons.robot className={styles.robot} />
      <Typography variant="captionSmall" className={styles.sourceName}>
        {t("inclusionAgent.source.robot")}
      </Typography>
    </Tooltip>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    display: "flex",
    aspectRatio: "1",
  }),
  wrapper: css({
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(4),
  }),
  robot: css({
    flex: "1 1",
    height: "auto",
    aspectRatio: "1",
  }),
  sourceName: css({
    color: "inherit",
    fontWeight: "normal",
  }),
});
